<section class="page">
  <form class="card form-grid" [formGroup]="form" (ngSubmit)="create()">
    <h1>Role Management</h1>
    <input formControlName="name" placeholder="Role name">
    <input formControlName="description" placeholder="Description">
    <button type="submit" [disabled]="form.invalid">Create Role</button>
  </form>
  <div class="card">
    <table class="table-sm">
      <tr>
        <th>Sr.No</th>
        <th>Name</th>
        <th>Description</th>
        <th>Status</th>
      </tr>
      @for (role of paginatedRoles; track role.id; let index = $index) {
        <tr>
          <td>{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
          <td>{{ role.name }}</td>
          <td>{{ role.description }}</td>
          <td>{{ role.is_active ? 'Active' : 'Inactive' }}</td>
        </tr>
      }
    </table>
    <div class="pagination">
      <span>Showing {{ paginatedRoles.length }} of {{ roles.length }} roles</span>
      <div>
        <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">Previous</button>
        <strong>{{ currentPage }} / {{ totalPages }}</strong>
        <button type="button" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">Next</button>
      </div>
    </div>
  </div>
</section>
